import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewChildren } from '@angular/core'
import { PathGroup } from '../path-group/path-group.model'
import { PathGroupService } from '../path-group/path-group.service'
import { ActivatedRoute, Router } from '@angular/router'
import { SignUpForm, User} from '../user/user.model'
import { SessionService } from '../session/session.service'
import { AppState } from '../app.service'
import { I18n } from '../i18n.service'
import { HomeUiService } from '../new-design/home-ui.service';
import { NotificationService } from '../notification/notification.service'
import { UserService } from '../user/user.service'
import { CordovaService } from '../cordova.service'
import { ThemeService } from '../theme/theme.service'
import { SpinnerService } from '../spinner.service'
import { CohortService } from '../cohorts/cohort.service'
import { ToasterService } from '../toaster.service'
import { expandOnEnterAnimation } from 'angular-animations'
import {AlertPathSelectV2Component } from '../alert-path-select-v2/alert-path-select-v2.component'
import { MatDialog } from "@angular/material/dialog"
import { ModalController } from '@ionic/angular';
import { AnimationsService } from 'src/app/shared/animations.service';

import { trigger, state, style, animate, transition } from '@angular/animations';
import { Constants } from '../constants/constants'

export interface SignUpByForm{
  [signUpByForm: string]: any
}

export interface Collapse {
  isCollapsable: boolean;
  isCollapsed: boolean;
}

export interface SetActivePath{
  [setActivePath: string]: any
}

@Component({
  selector: 'app-path-select',
  templateUrl: './path-select.component.html',
  styleUrls: ['./path-select.component.scss'],
  animations:[
    expandOnEnterAnimation({ duration: 150 }),
    trigger('fadeInOut', [
      state('in', style({ opacity: 1, height: '*' })),
      transition(':enter', [
        style({ opacity: 0 }), // Remove height styling
        animate('1s ease-out', style({ opacity: 1 })) // Adjust duration to make it slower
      ]),
      transition(':leave', [
        animate('0.2s ease-in', style({ opacity: 0, height: 0 }))
      ])
    ]),
    trigger('fadeInOut2', [
      state('in', style({ opacity: 1, transform: 'scale(1)', maxHeight: '1000px' })),
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)', maxHeight: 0 }),
        animate('0.5s ease', style({ opacity: 1, transform: 'scale(1)', maxHeight: '1000px', height: '*' }))
      ]),
      transition(':leave', [
        animate('0.5s ease', style({ opacity: 0, transform: 'scale(0.95)', maxHeight: 0, height: 0 }))
      ])
    ])

  ]
  // animations: [
  //   trigger('modalAnimation', [
  //     state('open', style({
  //       transform: 'translateY(0%)',
  //       opacity: 1
  //     })),
  //     state('closed', style({
  //       transform: 'translateY(100%)',
  //       opacity: 0
  //     })),
  //     transition('closed => open', [
  //       animate('100ms ease-out') // Adjust the duration as needed
  //     ]),
  //     transition('open => closed', [
  //       animate('100ms ease-in') // Adjust the duration as needed
  //     ]),
  //   ]),
  // ],
  
  
})
export class PathSelectComponent implements OnInit {

  clientId: Number
  collapse: Array<Collapse>=[];
  clientBackgroundImageUrl: string
  activePathId?: number
  currentPathGroup: PathGroup
  pathGroups: PathGroup[]
  origin: string
  data: SignUpForm
  loading = false
  onCordova = false
  public formSignUp: SignUpByForm
  public activePath: SetActivePath
  cohorts: any
  cohortId?: number
  pathList: any
  user: User
  enbleBtn:boolean;
  isMobile: boolean
  clientImage;
  verifyEmail: string;
  isCohort: any

  @ViewChild('path') path: ElementRef;
  @ViewChild('textCount') textCount: ElementRef;
  @ViewChildren('cardElement') cardElement: ElementRef[];
  @ViewChild('dynamicModal') dynamicModal: AlertPathSelectV2Component;
  isDialogOpen = false;
  dialogState: 'open' | 'closed' = 'closed';
  maxHeight: number = 80;
  activeCohortId: any; 
  modalClosed = true;
  cohortSelectedPaths = []
  filteredPathsGroups = [];
  /**
   * Series sections for the phone's Cycle list, in the order the client set. Empty means the flat
   * list this screen has always shown — a client with no Series sees exactly what it saw before.
   *
   * `startIndex` is where the section's first card sits in the whole list. The card highlight and
   * the description clamp are both keyed by position in the DOM, and every section restarts its
   * own `*ngFor` at 0, so the running total is what keeps them pointing at the right card.
   */
  seriesGroups: Array<{ id: any; name: string; color?: string; paths: any[]; startIndex: number }> = [];
  /** Which section the filter is showing: 'all', one Series id, or 'other'. */
  seriesFilter: any = 'all';
  /** Built once with the sections — a getter would hand the template a new array every pass. */
  seriesFilterOptions: Array<{ id: any; name: string }> = [];
  /** The header on the phone's filter dialog. A field, for the same reason. */
  filterInterfaceOptions: any = {};
  showVerification = false
  showCohort = true
  translatedPathSelectAgreementText;
  constants = Constants;
  selectInterfaceOptions = { cssClass: 'select-cohort-custom' }
  constructor(
    private i18n: I18n,
    private appState: AppState,
    private pathGroupService: PathGroupService,
    private spinnerService: SpinnerService,
    private notificationService: NotificationService,
    private userService: UserService,
    private sessionService: SessionService,
    private themeService: ThemeService,
    public route: ActivatedRoute,
    private router: Router,
    private render: Renderer2,
    private cordovaService: CordovaService,
    public cohortService: CohortService,
    private toasterService: ToasterService,
    private matDialog: MatDialog,
    private modalController: ModalController,
    public homeUIService: HomeUiService,
    private animationService: AnimationsService,
  ) {
    this.onCordova = this.cordovaService.onCordova
    this.user = this.appState.get('currentUser')
    this.isMobile = this.appState.get('isMobile')
    console.log('this.user :', this.user);
    this.translatedPathSelectAgreementText = this.i18n.t(`By continuing, you're agreeing to ${this.constants.appName}’s`)
    this.origin = this.route.snapshot.queryParamMap.get('origin')
    const activePathId = localStorage.getItem('activePathId')
    if (activePathId) {
      this.activePathId = parseInt(activePathId, 10)
    }
    const clientId = localStorage.getItem('clientId')
    if (clientId) {
      this.clientId = parseInt(clientId, 10)
    }
    this.clientImage = this.appState.get('clientImage')

    // LUMBA-1396
    this.setClientBackground()
    if (this.origin === 'signup') {
      this.data = JSON.parse(this.appState.get('signupData'))
    } else if (this.origin === 'settings') {
      if (!this.appState.get('currentUser')) {
        this.loading = false
        this.goBack()
        return
      }
      const token = localStorage.getItem('token')
      if (!token) {
        this.loading = false
        return
      }
       this.loading = false
      // this.userService.pathGroupsByToken(localStorage.getItem('token'))
      //   .subscribe(pathGroups => {
      //     this.pathGroups = pathGroups
      //     this.loading = false
      //   }, () => {
      //     this.loading = false
      //   })
    } else if (this.origin === 'login') {
      const email = localStorage.getItem('lastUserEmail')
      const clientSubDomain = this.themeService.getSubDomain() // LUMBA-1408
      if (!email || !(this.clientId)) {
        this.loading = false
        return
      }
      this.userService.pathGroupsByClientEmail(email, this.clientId.toString(), clientSubDomain, this.onCordova)
        .subscribe(result => {
          this.pathGroups = result.clientPathGroups
          const errors = result?.errors
          if (errors.length > 0) {  // LUMBA-1391
            const messages = errors.map(e => this.i18n.t(e))
            this.toasterService.error(this.i18n.t(messages.join('<br>')))
          }
          this.loading = false
        }, error => {
          this.loading = false
          const messages = error.graphQLErrors.map(e => e.message)
          this.toasterService.error(this.i18n.t(messages.join('<br>')))
        })
    }
  }

  ngOnInit() {   
    if (!this.pathGroups) {
      this.pathGroups = this.appState.get('clientPathGroups')
      console.log('this.pathGroups :', this.pathGroups);
      this.getCohorts(this.pathGroups[0].clientId)
    }
    this.buildSeriesGroups()
    if (!this.pathGroups && this.origin === 'signup') {  // LUMBA-1392
      this.goToSignup()
    }
    if (!this.activePathId) {
      this.loading = false
      return
    }
    if (!this.clientId) {
      this.loading = false
      return
    } 
  }
  /**
   * "Select cohort", including when the cohort has nothing in it.
   *
   * The button used to be `filteredPathsGroups.length && openModal()`, so a cohort with no Cycles
   * allocated made it do nothing at all — the click evaluated to false and the learner was left
   * tapping a button that only greyed itself out.
   */
  /**
   * The Cycles on offer, grouped the way the server grouped them — the same sections the modal on
   * web shows, which this page never had.
   *
   * Empty whenever the client has no Series, and the flat list below is then what it always was.
   * A Cycle in two Series is offered under both; selection keys on its id, so choosing it in one
   * place is choosing it everywhere.
   */
  /**
   * The Cycles this page is offering right now.
   *
   * With cohorts on that is the selected cohort's list, which is what the page renders and what the
   * learner can actually pick from; with cohorts off it is the client's own list. Grouping against
   * `pathGroups` either way offered Series sections full of Cycles the cohort does not include.
   */
  private offeredPaths(): any[] {
    const cohortMode = this.pathGroups && this.pathGroups[0]?.client?.isCohort
    return cohortMode ? (this.pathList || []) : (this.pathGroups || [])
  }

  private buildSeriesGroups(): void {
    const offering = this.offeredPaths()
    const offered = new Set((offering || []).map((path: any) => String(path?.id)))
    // Filtered against what this screen offers: the cohort already narrowed that, and the grouping
    // must not widen it again.
    const keep = (paths: any[]) => (paths || []).filter((path: any) => offered.has(String(path?.id)))

    const groups = (this.appState.get('clientSeriesGroups') || [])
      // A disabled Series is a soft delete — it shows nowhere. The server omits them and lets their
      // Cycles fall through to the ungrouped list; this is here for the case where one arrives.
      .filter((series: any) => series?.enabled !== false)
      .map((series: any) => ({ ...series, paths: keep(series?.paths) }))
      .filter((series: any) => series.paths.length > 0)
      .sort((a: any, b: any) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0))

    // Other is everything on offer that no surviving group claims — derived rather than read from
    // clientUngroupedPaths, so a Cycle whose only Series was disabled still has somewhere to be.
    const claimed = new Set<string>()
    groups.forEach((group: any) => group.paths.forEach((path: any) => claimed.add(String(path?.id))))
    const ungrouped = (offering || [])
      .filter((path: any) => path?.id != null && !claimed.has(String(path.id)))
    if (groups.length > 0 && ungrouped.length > 0) {
      groups.push({ id: 'other', name: this.i18n.t('Other'), paths: ungrouped })
    }

    let running = 0
    groups.forEach((group: any) => {
      group.startIndex = running
      running += group.paths.length
    })
    this.seriesGroups = groups

    this.seriesFilterOptions = groups.length > 0
      ? [{ id: 'all', name: this.i18n.t('All') },
         ...groups.map((group: any) => ({ id: group.id, name: group.name }))]
      : []
    this.filterInterfaceOptions = { header: this.i18n.t('Filter Cycles') }
    // A filter left pointing at a Series this screen no longer offers would show nothing at all.
    if (!this.seriesFilterOptions.some((option) => option.id === this.seriesFilter)) {
      this.seriesFilter = 'all'
    }
  }

  /** Whether a section is on screen under the current filter. */
  showsSection(id: any): boolean {
    return this.seriesFilter === 'all' || this.seriesFilter === id
  }

  selectSeriesFilter(id: any): void {
    this.seriesFilter = id
  }

  /** Stable identity for the chip row, so a rebuild does not re-create every button. */
  trackFilterOption(_index: number, option: { id: any }) {
    return option?.id
  }

  selectCohort() {
    if (!this.filteredPathsGroups?.length) {
      this.toasterService.warning(
        this.i18n.t('No cycles have been allocated to this cohort. Please contact your administrator.')
      )
      return
    }
    this.openModal()
  }

  async openModal(){
    this.cohortId = this.activeCohortId;
    this.modalClosed = false
    const modal = await this.modalController.create({
      component: AlertPathSelectV2Component,
      cssClass: 'select-path-model-custom',
      showBackdrop:false,
      componentProps: {
        data: this.filteredPathsGroups,
      },
      enterAnimation: this.animationService.slideLeftTopEnterAnimation ,
      leaveAnimation: this.animationService.slideLeftTopLeaveAnimation
    });
    
    modal.onDidDismiss().then((result) => {
      if (result.role === 'success') { 
        const selectedPath = result.data?.path; 
        this.activePathId = selectedPath?.id
        this.currentPathGroup = result.data?.path
        this.openShowVerification()
      } else {
        this.modalClosed = true
      }
    });
  await modal.present();
  }
 
  openShowVerification() {
   this.signUpV2()
    this.showCohort = false;
    this.showVerification = true
  }
  openDialog() {
    this.isDialogOpen = true;
    this.dialogState = 'open';
  }

  closeDialog() {
    this.dialogState = 'closed';
  }

  onDialogClosed() {
    this.isDialogOpen = false;
  }

  selectPath(i) {
    console.log("value i ..", i);
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--theme-color');

   let id = document.getElementsByClassName('add-border')

   for(let j=0; j<id?.length;j++) {
    if(i==j) {
    //  this.currentPathGroup = this.pathGroups[1].paths[i]
   
      id[j].setAttribute('style',`border:2px solid ${primaryColor};display:flex; border-radius: 7px; justify-content:center; width:97%;padding:1rem 0.7rem;`);
    }
    else {
      id[j].setAttribute('style','border:2px solid transparent;display:flex;width:97%;justify-content:center;padding:1rem 0.7rem;');
    }
 //   this.selectActivePath(path.id);
   }
   
  //  if(id){
  //   id[i].setAttribute('style','border:1px solid red');
  //  }
  }
  getCollapsedText(list) {
   // this.currentPathGroup = list
    if(list?.length>0 && list?.length==this.collapse?.length) {
      return true;
    }
   else if( list?.length>this.collapse?.length){
      this.cardElement?.forEach((cardElement, index) => {
     const cardHeight = cardElement.nativeElement.offsetHeight;
    //  const lineHeight = this.textCount?.nativeElement?.offsetHeight;
     if (cardHeight > this.maxHeight) {
       this.collapse.push({isCollapsable :true,isCollapsed :true})
       this.render.addClass(this.textCount.nativeElement, 'reply-texts');
     
   }else {
     this.collapse.push({isCollapsable :false,isCollapsed :false})
  
   }
  
   });
  return true;
  
    }
    else {
      return true;
    }
  }
  // LUMBA-1408
  setClientBackground() {
    const data = this.themeService.themeData
    console.log('data :', data);
    if (data && data.clientBackgroundImageUrl) {
      this.clientBackgroundImageUrl = data.clientBackgroundImageUrl
    } else if (this.clientBackgroundImageUrl) {

    } else if (this.origin === 'signup') {
      this.clientBackgroundImageUrl = 'assets/images/default-background.jpg'
    } else if (this.origin === 'settings') {
      this.clientBackgroundImageUrl = this.appState.get('currentClient').backgroundImageUrl
    } else if (this.origin === 'login') {
      this.clientBackgroundImageUrl = 'assets/images/default-background.jpg'
    }
  }

  selectActivePath(i,activePathId) {
    let currentPathGroup
    this.enbleBtn =true
    this.selectPath(i);
    this.activePathId = activePathId
    // this.pathGroups.forEach(pathGroup => {
     this.pathGroups.forEach(path => {
        if(String(path.id) === String(activePathId)){
          currentPathGroup = path
        }
      });
    // });

    // The Cycles on screen come from the cohort (pathList), but this lookup only searched
    // pathGroups/clientPathGroups, which carries the first cohort's Cycles. Picking a Cycle from
    // any other cohort therefore left currentPathGroup undefined, and signUpV2() then threw on
    // currentPathGroup.client.id -- dead-ending the flow with no error and no verification email.
    // Series-group Cycles are covered too: buildSeriesGroups() filters against pathList, so every
    // id shown anywhere on this screen is in it.
    if (!currentPathGroup) {
      const fromCohort = (this.pathList || []).find((path: any) => String(path?.id) === String(activePathId))
      if (fromCohort) {
        currentPathGroup = { ...fromCohort, client: fromCohort.client ?? this.pathGroups?.[0]?.client }
      }
    }

    console.log('pathGrpId :', currentPathGroup);
    this.currentPathGroup = currentPathGroup
    //this.getCollapsedText(this.currentPathGroup);
   this.textExpand(i)
    //this.getCollapsedText(this.pathGroups[0].paths)
  }

  selectActivePathGroup(pathGroup) {
    console.log('pathGroup :', pathGroup);
    this.currentPathGroup = pathGroup
    this.getCollapsedText(this.currentPathGroup);
  }

  goToLogin() {
    this.router.navigate([`login`])
  }

  goToSignup() {
    this.router.navigate([`signup`])
  }

  goToMain() {
    this.router.navigate([`/main`])
  }

  goBack() {
    this.appState.set('signUpForm', this.data)
    this.appState.set('signupData',undefined)
    if (this.origin === 'signup') {
      this.goToSignup()
    } else if (this.origin === 'login') {
      this.goToLogin()
    } else if (this.origin === 'settings') {
      this.goToMain()
    }
  }
  // selectcohart(){
  //   const dialogRef = this.matDialog.open(AlertSelectPathComponent)
  //   dialogRef.afterClosed().subscribe((result) => {
  //   })
  // }
  
  signUp() {
    console.log('this.currentPathGroup.id :', this.currentPathGroup?.id);
    console.log('this.currentPathGroup :', this.currentPathGroup);
    console.log('this.activePathId :', this.activePathId);
    console.log('this.cohortId :', this.cohortId);

    if (!this.activePathId || !this.currentPathGroup.id) {
      return false
    }
    this.loading = true
    this.data['activePathId'] = this.activePathId
    this.data['cohortId'] = this.cohortId
    this.pathGroupService.getPathGroup(this.currentPathGroup.id).subscribe(pathGroup => {
        this.clientId = pathGroup.client.id
        this.clientBackgroundImageUrl = pathGroup.client.backgroundImageUrl

        console.log("Path data ",pathGroup);

        localStorage.setItem('clientId', this.clientId.toString())
        localStorage.setItem('activePathId', this.activePathId.toString())
        localStorage.setItem('activePathGroupId', pathGroup.id.toString())
        localStorage.setItem('clientBackgroundImageUrl', pathGroup.client.backgroundImageUrl)
        this.currentPathGroup = pathGroup
        this.data['clientId'] = this.clientId
        this.userService.signUp(new User(this.data))
          .subscribe(result => {
            this.formSignUp = result.data
              const user = this.formSignUp.signUpByForm.user
              const errors = this.formSignUp.signUpByForm.errors
              this.loading = false
              if (user && !errors) {
                this.verifyEmail = this.data.email;
                this.appState.set('verifyEmail', this.data.email)
                this.themeService.apply(pathGroup, pathGroup.client)  // LUMBA-1428
                this.goToLogin()
              } else if (errors && errors.length > 0) {
                console.log(errors)
                const messages = errors?.map(e => this.i18n.t(e))
                this.notificationService.alert(messages.join('<br>'), 'Oops!', {'enableHtml': true})
              }
            },
            (error) => {
            console.log('error :', error);
              this.loading = false
              const messages = error.graphQLErrors.map(e => e.message)
              this.notificationService.alert(messages.join('<br>'), 'Oops!')
            }
          )
      },
      (error) => {
        console.log('error :', error);
        this.loading = false
        this.router.navigate([`/not-found`])

      })
  }

   signUpV2() {
    console.log('this.currentPathGroup.id :', this.currentPathGroup?.id);
    console.log('this.currentPathGroup :', this.currentPathGroup);
    console.log('this.activePathId :', this.activePathId);
    console.log('this.cohortId :', this.cohortId);

    if (!this.activePathId) {
      return false
    }
    this.loading = true
    this.data['activePathId'] = this.activePathId
    this.data['cohortId'] = this.cohortId
        this.clientId = this.currentPathGroup.client.id
        this.clientBackgroundImageUrl = this.currentPathGroup.client.backgroundImageUrl

        console.log("Path data ",this.currentPathGroup);

        localStorage.setItem('clientId', this.clientId.toString())
        localStorage.setItem('activePathId', this.activePathId.toString())
        localStorage.setItem('activePathGroupId', this.currentPathGroup.id.toString())
        localStorage.setItem('clientBackgroundImageUrl', this.currentPathGroup.client.backgroundImageUrl)
        this.data['clientId'] = this.clientId
        this.userService.signUp(new User(this.data))
          .subscribe(result => {
            this.formSignUp = result.data
              const user = this.formSignUp.signUpByForm.user
              const errors = this.formSignUp.signUpByForm.errors
              this.loading = false
              if (user && !errors) {
                this.verifyEmail = this.data.email;
                this.appState.set('verifyEmail', this.data.email)
                this.themeService.apply(this.currentPathGroup, this.currentPathGroup.client)  // LUMBA-1428
                this.goToLogin()
              } else if (errors && errors.length > 0) {
                console.log(errors)
                const messages = errors?.map(e => this.i18n.t(e))
                this.notificationService.alert(messages.join('<br>'), 'Oops!', {'enableHtml': true})
              }
            },
            (error) => {
            console.log('error :', error);
              this.loading = false
              const messages = error.graphQLErrors.map(e => e.message)
              this.notificationService.alert(messages.join('<br>'), 'Oops!')
            }
          )
  
  }
  updateActivePath() {
    this.loading = true
    this.appState.set('activePathId', this.activePathId)  // LUMBA-1402
    this.appState.set('changePath', true)
    this.goToLogin()
  }

  setActivePath() {
    this.loading = true
    this.pathGroupService.setActivePath(this.activePathId, this.appState.get('currentUser').id)
      .subscribe( response => {
        this.activePath = response.data
        const data = this.activePath.setActivePath
        console.log("Path Data : ",data)
        this.sessionService.changePathData(data)
        this.goBack()
      }
    )
  }

  getCohorts(clientId){
    if (clientId) {
     // this.spinnerService.on()
      this.cohortService.getCohort(clientId).subscribe((cohort) => {
        //this.spinnerService.off()
        this.cohorts = cohort?.data
        this.isCohort = this.pathGroups && this.pathGroups[0]?.client.isCohort
        if(!this.isCohort) {
          this.activeCohortId = null
        }else {
          this.activeCohortId = this.cohorts && this.cohorts?.length > 0 ? this.cohorts[0].id : null;
        }
        this.fetchCohortPaths(this.cohorts)
        this.filteredPathsGroups = this.getPathsFromCohortForWeb(this.activeCohortId);
        console.log('this.cohort', this.cohorts)
        
      },
      (error)=>{
        console.log("err",error)
        this.spinnerService.off()
      });
    } else {
      this.spinnerService.off()
      console.log('no cohort found')
    } 
  }

  fetchCohortPaths(cohorts) 
  {
    let user = this.appState.get("currentUser");
      let cohortPathList = []
    cohorts?.forEach(element => {
      if (element.id == user?.cohortId) {
        cohortPathList = element?.paths ? [...element.paths] : []
      }
    });
    if(user?.adhocPaths && user?.adhocPaths?.length > 0){

      cohortPathList.push(...user.adhocPaths)
    }
    this.appState.set('cohortPathsCount',cohortPathList?.length); 

  }
  selectActiveCohort(cohort){
    this.cohortId = cohort?.detail?.value
    this.enbleBtn =false;
    console.log('this.cohortId :', this.cohortId);
    this.getPathsFromCohort(this.cohortId)
  }
  selectActiveCohortWeb(cohort){
    this.cohortId = cohort
    this.enbleBtn =false;
    this.getPathsFromCohortForWeb(this.cohortId)
  }
getPathsFromCohortForWeb(cohortId) {
  this.filteredPathsGroups = [];

  // Ids arrive from the <select> as well as from the API, so compare them as strings -- a
  // number/string mismatch here used to fall through to the "all path groups" branch below and
  // offer the learner every Cycle on the client, not the ones in the cohort they picked.
  const findCohort = (id: any) => this.cohorts?.find(cohort => String(cohort.id) === String(id));

  // If cohortId is not provided or not found, return all path groups and paths
  if (!cohortId || !findCohort(cohortId)) {
      this.pathGroups.forEach(matchingPaths => {
          // const matchingPaths = group.paths.map(path => {
          //     return path;
          // });
          if (matchingPaths) {
              this.filteredPathsGroups.push(matchingPaths
                  // id: group.id,
                  // groupName: group.name,
                  // paths: matchingPaths
              );
          }
      });
  } else {
      // Drive off the cohort's own Cycles, the way the mobile path (getPathsFromCohort) already
      // does. This used to intersect cohort.paths ids against this.pathGroups (clientPathGroups),
      // which only ever matched for the cohort whose Cycles are in that list -- the preselected
      // first one. Every other cohort intersected to nothing, so picking it showed
      // "No cycles have been allocated to this cohort" even when the cohort was full.
      const cohort = findCohort(cohortId);
      const cohortPaths = cohort?.paths ?? [];
      cohortPaths.forEach(path => {
          // Prefer the clientPathGroups entry when there is one, since it is the richer payload;
          // otherwise use the cohort's own copy, which carries the same name/pathImage/
          // pathDescription the select modal renders.
          const fromGroups = this.pathGroups?.find(group => String(group.id) === String(path.id));
          // The cohort's own copy has no `client`, but signUpV2() reads
          // currentPathGroup.client.{id,backgroundImageUrl} and themeService.apply() takes it too --
          // without it signUpV2() throws before it ever calls signUp(), which silently skipped the
          // verification email AND left showVerification false, so the screen never appeared.
          // Every cohort here belongs to the client we just fetched cohorts for, so borrowing it
          // from the path groups is the same client either way.
          this.filteredPathsGroups.push(
            fromGroups ?? { ...path, client: path?.client ?? this.pathGroups?.[0]?.client }
          );
      });
  }
  // console.log('filtered path group', this.filteredPathsGroups);
  return this.filteredPathsGroups;
}
resendVerificationEmail() {
  // if (!this.verifyEmail) {
  //   console.log('inside ifff')
  //   return false;
  // }
  if(!this.verifyEmail && this.appState.get('verifyEmail')) {
    this.verifyEmail = this.appState.get('verifyEmail')
  }
  else if(!this.verifyEmail && !this.appState.get('verifyEmail')){
    let data = JSON.parse(this.appState.get('signupData'))
   if(data) {
    this.verifyEmail= data?.email;
   }
  }

  this.userService.resendVerificationEmail(this.verifyEmail).then(
    (response) => {
      if (response && response.success && response.message) {
        this.toasterService.success(this.i18n.t(
          "An email has been sent to this address."
        ));
      }
      return response.data;
    },
    (error) => {
      console.log("sendForgotPassword error", error);
      this.toasterService.error(this.i18n.t("Email not found"));
    }
  );

  return false;
}
  getPathsFromCohort(cohortId){
    this.cohorts.forEach(element => {
      if (element.id == cohortId) {
        this.pathList = element.paths
      }
    });
    // The offered set just changed, so the Series sections have to be built against the new one —
    // otherwise they keep the previous cohort's Cycles, or none at all on the first selection.
    this.buildSeriesGroups()
  }
  textExpand(val) {
    for(let j=0;j<this.collapse?.length;j++) {
      if(j==val){
         this.collapse[val].isCollapsed =false;
         this.collapse[val].isCollapsable =true; 
      }
      else {
        this.collapse[j].isCollapsed =true;
        this.collapse[j].isCollapsable =true; 
      }
    }
    // if(collpase){
    //   // this.render.removeClass(this.textCount.nativeElement, 'reply-texts');
    //   path.isCollapsed = false;
    //   path.isCollapsable = true;
    // }
    // else {
    //   // this.render.addClass(this.textCount.nativeElement, 'reply-texts');
    //   path.isCollapsed = true;
    //   path.isCollapsable = true;
    // }
    //this.cdRef.detectChanges();
  }

}
